export class AuditSummary {
  public AttributeName: string;
  public ClaimCount: number;
  public InitialRiskAmount: number;
  public ApprovedRecoupmentAmount: number;
  public ActualRecoupmentAmount: number;
}

